// src/pages/Plus.js
import { useMemo } from 'react';
import { drawCards } from '../data/cardsApi';
import { Card } from '../components/Card';
import { PageShell, PageTitle, Divider, SectionLabel } from '../components/PageShell';
import { C, FONTS } from '../styles/theme';

export function Plus({ favs, onFav }) {
  const conseils   = useMemo(() => drawCards({ type: 'conseil',   context: 'general', maxIntensity: 3 }, 10), []);
  const ressources = useMemo(() => drawCards({ type: 'ressource', context: 'general', maxIntensity: 3 }, 10), []);

  return (
    <PageShell>
      <PageTitle>Aller plus loin</PageTitle>

      <SectionLabel>💡 Conseils</SectionLabel>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 36 }}>
        {conseils.map(card => (
          <Card key={card.id} card={card}
            isFav={favs.some(f => f.id === card.id)} onFav={onFav} compact />
        ))}
      </div>

      <Divider />

      <div style={{ marginTop: 28 }}>
        <SectionLabel>📚 Ressources</SectionLabel>
        <div style={{ background: C.bgCard, borderRadius: 20, border: `1px solid ${C.sand}`, overflow: 'hidden' }}>
          {ressources.map((card, i) => {
            const isFav = favs.some(f => f.id === card.id);
            return (
              <div key={card.id} style={{
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                padding: '16px 20px',
                borderBottom: i < ressources.length - 1 ? `1px solid ${C.sand}` : 'none',
              }}>
                <span style={{ fontSize: 15, color: C.text, flex: 1 }}>{card.text}</span>
                <button onClick={() => onFav(card)} style={{ background: 'none', border: 'none', padding: '0 0 0 12px', cursor: 'pointer' }}>
                  <svg width="17" height="17" viewBox="0 0 24 24"
                    fill={isFav ? C.roseDark : 'none'} stroke={C.roseDark} strokeWidth="1.8">
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
                  </svg>
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </PageShell>
  );
}
